module.exports = __webpack_public_path__ + "img/image3.7bd65285.png";